import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useMemo } from "react";
import { BoundingBoxAvatar } from "~/components/BoundingBox/components/BoundingBoxAvatar";
import { BOUNDING_BOX_LAYER_Z_INDEX } from "~/components/BoundingBox/constants";
import { useBoundingBoxTextPosition } from "~/components/BoundingBox/hooks/useBoundingBoxTextPosition";
import { getHorizontalOpposite } from "~/components/BoundingBox/types";
import { usePopperContainer } from "~/hooks/usePopperContainer";
const BOUNDING_BOX_AVATAR_TOP_PADDING = 10;
export const BoundingBoxTextContainer = /*#__PURE__*/ memo((param)=>{
    let { startX, endY, endX, containerLeft, containerWidth, containerHeight, containerRef, children, user } = param;
    const { offsetBottom, offsetLeft, position } = useBoundingBoxTextPosition({
        containerWidth,
        containerHeight,
        containerLeft,
        endY,
        endX,
        startX
    });
    const floatingCommentOptions = useMemo(()=>({
            placement: "bottom-start",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: (param)=>{
                            let { popper } = param;
                            const leftOffset = position.includes("right") ? offsetLeft + 1 : offsetLeft - popper.width + 2;
                            return [
                                leftOffset,
                                -offsetBottom - popper.height + 32
                            ];
                        }
                    }
                }
            ]
        }), [
        offsetLeft,
        offsetBottom,
        position
    ]);
    const { PopperContainer, popperInstance } = usePopperContainer({
        containerRef,
        options: floatingCommentOptions,
        usePortal: true
    });
    useEffect(()=>{
        var _popperInstance_current;
        (_popperInstance_current = popperInstance.current) === null || _popperInstance_current === void 0 ? void 0 : _popperInstance_current.update();
    }, [
        containerLeft,
        popperInstance
    ]);
    const Avatar = useMemo(()=>/*#__PURE__*/ _jsx("div", {
            "data-theme": "dark",
            className: "relative",
            style: {
                paddingTop: BOUNDING_BOX_AVATAR_TOP_PADDING
            },
            children: /*#__PURE__*/ _jsx(BoundingBoxAvatar, {
                // avatar's direction is opposite to comment's position
                direction: getHorizontalOpposite(position),
                account: user
            })
        }), [
        position,
        user
    ]);
    return /*#__PURE__*/ _jsx(PopperContainer, {
        style: {
            zIndex: BOUNDING_BOX_LAYER_Z_INDEX + 1
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex",
            children: [
                position.includes("right") && Avatar,
                children,
                position.includes("left") && Avatar
            ]
        })
    });
});
BoundingBoxTextContainer.displayName = "BoundingBoxTextContainer";
